import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ScrollableBox = styled(Box)({
  overflowX: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const ItemButton = styled(Button)({
  flex: '0 0 auto',
  marginRight: '1rem',
  boxShadow: 'none',
  backgroundColor: 'transparent',
});
